<template>
  <div class="container-list">
    <div class="common-page common-head">
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
    </div>
    <div class="flex">
      <unitList
        v-show="!($store.state.user.userInfo.natureId == 2)"
        @select="getUnit"
      ></unitList>
      <div class="flex1">
        <div
          class="common-page common-tool-bar"
          style="justify-content: space-between"
        >
          <div class="common-page common-head-title">
            <i class="icon-tr--detailed" style="padding-right: 5px"></i>
            设备状态列表
          </div>
          <div>
            <div class="btn" @click="showDia = true" style="margin-right: 10px">
              <i class="icon-tr-search"></i>查询
            </div>
            <div class="btn" @click="assigned = true">分配</div>
          </div>
        </div>
        <div class="common-page common-list">
          <el-table :data="list" class="">
            <el-table-column prop="c_name" label="巡查点编号" align="center">
            </el-table-column>
            <el-table-column prop="c_number" label="巡查点名称" align="center">
            </el-table-column>
            <el-table-column prop="c_address" align="center" label="区域">
            </el-table-column>
            <el-table-column prop="mname" align="center" label="巡查人">
            </el-table-column>
            <el-table-column prop="cname" align="center" label="巡查时间段">
            </el-table-column>
            <el-table-column label="操作" align="center" width="160px">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="check(scope.row, scope.$index)"
                  >派发</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="pageChange"
          :page-size="10"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="showDia = false" size="small">取消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="分配"
      :visible.sync="assigned"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="assignedForm"
        :remote="remoteFuncs"
        :value="assData"
        ref="assignedForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="assigned = false" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyList, switchCompany } from "../../api/company";
import unitList from "@/components/unitList";
export default {
  data() {
    return {
      list: [],
      params: { page: 1 },
      total: 0,
      showDia: false,
      assigned: false,
      searchForm: this.$getForm("planSearch"),
      assignedForm: this.$getForm("planAssign"),
      editData: {},
      assData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  components: {
    unitList,
  },
  methods: {
    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getList();
        })
        .catch((err) => {});
    },
    getList() {
      getCompanyList(this.params)
        .then((res) => {
          this.total = res.data.count;
          this.list = res.data.list;
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    getUnit(val) {},
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped></style>
